import { connect } from 'react-redux';
import PlanRenewal from './PlanRenewal';
import { isSubscriptionEnabledSelector } from '../../../reducers/subscriptionSwitch';
import {
  currentSubscriptionNextRenewalDateSelector,
  currentSubscriptionSelector,
  currentSubscriptionTerminationDate,
  isLineOFFSelector,
} from '../../../modules/Dashboard';
import { hasNextPlanSelector } from '../../../modules/NextPlan';

const mapStateToProps = state => ({
  isModeOn: isSubscriptionEnabledSelector(state),
  nextRenewalDate: currentSubscriptionNextRenewalDateSelector(state),
  subscription: currentSubscriptionSelector(state),
  hasNextPlan: hasNextPlanSelector(state),
  isLineOFF: isLineOFFSelector(state),
  terminationDate: currentSubscriptionTerminationDate(state),
});

export default connect(mapStateToProps)(PlanRenewal);
